module.exports = __webpack_public_path__ + "img/fr6.f43a3189.png";